<template>
  <v-list-group :value="false">
    <template v-slot:activator>
      <v-list-item-icon class="d-flex align-center justify-center mx-0" :data-id="`menu-${slugify(menu.titulo)}`">
        <v-img max-width="30" max-height="30" :src="menu.icon" />
      </v-list-item-icon>

      <v-list-item-title class="ms-5 white--text" :style="{ whiteSpace: 'normal' }">
        {{ menu.titulo }}
      </v-list-item-title>
    </template>

    <div class="ps-5 py-1">
      <list-item
        v-if="submenu.exibir ? submenu.exibir == 's' : true"
        v-for="(submenu, i) in menu.itens"
        @modalAppAgenda="$emit('modalAppAgenda')"
        @action="$emit('action', $event)"
        :item="submenu"
        :key="'menu-professor-' + i"
      />
    </div>
  </v-list-group>
</template>

<script>
import ListItem from "./ListItem.vue";
export default {
  name: "ListGroupItem",
  props: {
    menu: { type: Object },
  },
  components: {
    ListItem,
  },
  methods: {
    slugify(texto) {
      return texto
        .normalize("NFD") // separa acentos das letras
        .replace(/[\u0300-\u036f]/g, "") // remove acentos
        .replace(/[^a-zA-Z0-9\s]/g, "") // remove caracteres especiais
        .trim() // remove espaços no início/fim
        .replace(/\s+/g, "_") // troca espaços por "_"
        .toLowerCase();
    }
  }
};
</script>

<style></style>
